module.exports = __webpack_public_path__ + "static/media/IMG_2416.9a13fbb3.jpeg";